import React from "react";

// Small garment illustrations drawn around (0,0) = the peg point at the top
// centre, about 70 units wide. Used on the login clothesline and the
// dashboard. Each takes an optional fill colour.

export const Pin = () => (
  <rect x="-3" y="-7" width="6" height="14" rx="2" className="kd-cl-pin" />
);

export const Tee = ({ color = "#06A0E0" }) => (
  <g>
    <path
      d="M-12 0 L-26 6 L-34 20 L-24 26 L-21 21 L-21 56 L21 56 L21 21 L24 26 L34 20 L26 6 L12 0 Q0 9 -12 0 Z"
      fill={color}
    />
    <path d="M-21 34 H21 M-21 42 H21" stroke="#FFFFFF" strokeWidth="3" opacity="0.55" />
  </g>
);

export const Onesie = ({ color = "#FFD45C" }) => (
  <g>
    <path
      d="M-10 0 L-24 5 L-31 17 L-22 22 L-18 17 L-18 40 Q-18 52 -8 56 L-6 64 L6 64 L8 56 Q18 52 18 40 L18 17 L22 22 L31 17 L24 5 L10 0 Q0 8 -10 0 Z"
      fill={color}
    />
    <circle cx="-3" cy="60" r="1.6" fill="#222222" />
    <circle cx="3" cy="60" r="1.6" fill="#222222" />
    <path d="M-7 26 Q0 31 7 26" stroke="#222222" strokeWidth="2" fill="none" strokeLinecap="round" />
    <circle cx="-6" cy="20" r="1.8" fill="#222222" />
    <circle cx="6" cy="20" r="1.8" fill="#222222" />
  </g>
);

export const Sock = ({ color = "#FF9F86" }) => (
  <g>
    <path
      d="M-9 0 H9 V30 Q9 37 15 40 L22 44 Q30 50 24 56 L2 56 Q-11 54 -9 40 Z"
      fill={color}
    />
    <rect x="-9" y="0" width="18" height="7" fill="#FFFFFF" opacity="0.6" />
    <rect x="-9" y="12" width="18" height="4" fill="#FFFFFF" opacity="0.45" />
  </g>
);

export const Dress = ({ color = "#A99BFF" }) => (
  <g>
    <path
      d="M-9 0 L-16 2 L-14 14 Q-17 18 -14 22 L-32 60 H32 L14 22 Q17 18 14 14 L16 2 L9 0 Q0 7 -9 0 Z"
      fill={color}
    />
    <path d="M-14 22 H14" stroke="#FFFFFF" strokeWidth="3" opacity="0.7" />
    <circle cx="-12" cy="44" r="2.5" fill="#FFFFFF" opacity="0.6" />
    <circle cx="4" cy="50" r="2.5" fill="#FFFFFF" opacity="0.6" />
    <circle cx="16" cy="40" r="2.5" fill="#FFFFFF" opacity="0.6" />
  </g>
);

export const Bib = ({ color = "#6FD3B5" }) => (
  <g>
    <path
      d="M-14 0 Q-14 12 -4 12 L-4 8 Q0 6 4 8 L4 12 Q14 12 14 0 Q24 6 24 24 Q24 46 0 46 Q-24 46 -24 24 Q-24 6 -14 0 Z"
      fill={color}
    />
    <path d="M-8 28 Q0 36 8 28" stroke="#FFFFFF" strokeWidth="3" fill="none" strokeLinecap="round" />
  </g>
);
